{
    "DependedByItem": {
        "type": "object",
        "properties": {
            "from": {
                "type": "object",
                "properties": {
                    "namespace": {
                        "type": "string"
                    },
                    "id": {
                        "type": "string"
                    }
                },
                "required": [
                    "namespace",
                    "id"
                ],
                "additionalProperties": false
            },
            "to": {
                "type": "object",
                "properties": {
                    "fragmentType": {
                        "type": "string"
                    },
                    "fragmentInstance": {
                        "type": "string"
                    },
                    "dependsOnId": {
                        "type": "string"
                    }
                },
                "required": [
                    "fragmentType",
                    "fragmentInstance",
                    "dependsOnId"
                ],
                "additionalProperties": false
            }
        },
        "required": [
            "from",
            "to"
        ],
        "isTopLevelDataNode": true,
        "additionalProperties": false
    }
}
